module.exports = __webpack_public_path__ + "static/img/android.2484558d.png";